import React from 'react';
import { Icons, IconButton } from "@curves/ui-base";
import { NavLink } from 'react-router-dom';
import { CLUB_INVENTORY_ROUTER } from '@icoach/router/routerPath';

const StockBox = () => {
    return (
        <IconButton component={NavLink} to={CLUB_INVENTORY_ROUTER.STOCK.OVERVIEW}>
            <Icons.Stock htmlColor="white" />
        </IconButton>
    );
};

export default StockBox;
